import React, { Component } from 'react';

export const withAutoScroll = Comp => props => (
  <AutoScroll>
    <Comp {...props} />
  </AutoScroll>
);

class AutoScroll extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      children,
    } = this.props;
    return children;
  }
}

export default AutoScroll;



// WEBPACK FOOTER //
// ./src/components/App/AutoScroll.js